import STEP_GROUPS from './groups';
import LAST from './lasts';
import MAIN from './main';
import MY_TAXES from './myTaxes';
import MY_PROPERTY from './myProperty';
import MY_INCOMES from './myIncomes';
import MY_INCOMES_AND_TAXDEDUCTIONS from './myIncomesAndTaxDeductions';

const STEPS = {
  [STEP_GROUPS.MAIN]: MAIN,
  [STEP_GROUPS.MY_TAXES]: MY_TAXES,
  [STEP_GROUPS.MY_INCOMES]: MY_INCOMES,
  [STEP_GROUPS.MY_INCOMES_AND_TAXDEDUCTIONS]: MY_INCOMES_AND_TAXDEDUCTIONS,
  [STEP_GROUPS.MY_PROPERTY]: MY_PROPERTY,
  [STEP_GROUPS.LAST]: LAST,
};
export default STEPS;
